export default __webpack_public_path__ + "static/assets/icon_cxg-25c81dcb04bb17fa0e8ad26da31ac22b.png";